import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { CreateCuratedTopicAction, TopicCreateAction } from '../../domains/topics/actions.types';

import { TopicCreation } from './types';

export type { TopicCreateAction };

const initialState: TopicCreation = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TopicCreation, TopicCreateAction | CreateCuratedTopicAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'TOPIC.CREATE_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.topicCreationId]: {
          id: action.payload.id,
          isExistingTopic: action.payload.isExistingTopic,
        },
      });
    case 'TOPIC.CREATE_AND_CURATE_FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.topicCreationId]: {
          id: action.payload.id,
          isExistingTopic: action.payload.isExistingTopic,
        },
      });
    case 'TOPIC.CREATE_REJECTED':
      return moveToRejected(state, [action.payload.topicCreationId], action.payload.error);
    case 'TOPIC.CREATE_AND_CURATE_REJECTED':
      return moveToRejected(state, [action.payload.topicCreationId], action.payload.error);
    case 'TOPIC.CREATE_PENDING':
      return moveToPending(state, [action.payload.topicCreationId]);
    case 'TOPIC.CREATE_AND_CURATE_PENDING':
      return moveToPending(state, [action.payload.topicCreationId]);
    case 'TOPIC.CREATE_RESET':
      return remove(state, [action.payload.topicCreationId]);
    case 'TOPIC.CREATE_AND_CURATE_RESET':
      return remove(state, [action.payload.topicCreationId]);
    default:
      return state;
  }
};

export default reducer;
